import { AxleOrgSyncOrgFragment } from "../../../../../../types";
import { CardMode } from "./DisplayCard";
import { DisplayList, RenderListItemArgs } from "./DisplayList";
import { OrgCard } from "./OrgCard";

interface OrgFilterArgs {
  isLinked: boolean;
  hasSearchQueryMatch: boolean;
  isSelected: boolean;
}

interface OrgsListBaseProps {
  selectedId: string | null;
  searchQuery: string;
  orgs: readonly AxleOrgSyncOrgFragment[];
  loading: boolean;
  title: string;
  columnMode: CardMode;
  filterOrg: (args: OrgFilterArgs) => boolean;
  onLink?: (org: AxleOrgSyncOrgFragment) => void;
  onSync?: (org: AxleOrgSyncOrgFragment) => void;
  onClick?: (org: AxleOrgSyncOrgFragment) => void;
}

export const OrgsListBase = ({
  selectedId,
  searchQuery,
  orgs: _orgs,
  loading,
  title,
  columnMode,
  filterOrg,
  onSync,
  onClick,
}: OrgsListBaseProps) => {
  const orgs = _orgs.filter(org => {
    const hasSearchQueryMatch = org.name.toLowerCase().includes(searchQuery.toLowerCase());
    const isLinked = org.axleOrgDocumentId !== null;
    const isSelected = org.id === selectedId;
    return filterOrg({ isLinked, hasSearchQueryMatch, isSelected });
  });

  const renderListItem = ({ key, ...restProps }: RenderListItemArgs<AxleOrgSyncOrgFragment>) => {
    return <OrgCard key={key} onSync={onSync} onClick={onClick} {...restProps} />;
  };

  return (
    <DisplayList
      title={title}
      columnMode={columnMode}
      renderListItem={renderListItem}
      elements={orgs}
      disabled={selectedId !== null}
      loading={loading}
      selectedId={selectedId}
    />
  );
};
